import * as React from 'react';
import classnames from 'classnames';
import { sortPrescriptionParameters } from '@grandvisionhq/utils';
import { PrescriptionFormColumnHeading } from '../PrescriptionFormColumnHeading/PrescriptionFormColumnHeading.js';
import { PrescriptionFormInputContainer } from '../PrescriptionFormInput/PrescriptionFormInputContainer.js';

const PrescriptionFormColumn = ({ id , className , hideSelectLabels , columnTitle , errorMessageId , parameters , selectedValues , validations , showValidation , onAttributeChange , 'data-t': dataT ,  })=>{
    const paramSortingOrder = sortPrescriptionParameters(parameters.map((p)=>p.name
    ));
    const sortedParams = [
        ...parameters
    ].sort(function(a, b) {
        return paramSortingOrder.indexOf(a.name) - paramSortingOrder.indexOf(b.name);
    });
    return /*#__PURE__*/ React.createElement("fieldset", {
        "data-t": "prescription-column-fieldset",
        className: className,
        "aria-label": columnTitle
    }, /*#__PURE__*/ React.createElement("div", {
        "data-t": dataT,
        className: classnames('prescription-column', {
            'prescription-column--hide-labels': hideSelectLabels
        })
    }, /*#__PURE__*/ React.createElement(PrescriptionFormColumnHeading, {
        id: id,
        className: "prescription-column__heading"
    }, columnTitle), sortedParams.map((parameter, index, array)=>/*#__PURE__*/ React.createElement(PrescriptionFormInputContainer, {
            key: parameter.name,
            parentId: id,
            parameter: parameter,
            onAttributeChange: onAttributeChange,
            isFirstItem: index === 0,
            isLastItem: index === array.length - 1,
            selectedValues: selectedValues,
            validations: validations,
            showValidation: showValidation,
            hideLabels: hideSelectLabels,
            errorMessageId: errorMessageId
        })
    )));
};
var PrescriptionFormColumn$1 = /*#__PURE__*/ React.memo(PrescriptionFormColumn);

export { PrescriptionFormColumn$1 as default };
//# sourceMappingURL=PrescriptionFormColumn.js.map
